import { ReactElement } from "react";
import Logo from "../../images/logo.png";
// login features images
import img1 from "../../images/assetsImg/headphone.png";
import img2 from "../../images/assetsImg/github.png";
import img3 from "../../images/assetsImg/messenger.png";
import img5 from "../../images/assetsImg/doller.png";
import img6 from "../../images/assetsImg/warning.png";
import img7 from "../../images/assetsImg/menus.png";
import img8 from "../../images/assetsImg/girlsbag.png";
import img9 from "../../images/assetsImg/quatition.png";
import img10 from "../../images/assetsImg/address.png";
import img11 from "../../images/assetsImg/track.png";

const LoginIntro = (): ReactElement => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
        borderRadius: "5px",
        boxShadow: "5px 5px 15px rgba(0,0,0,0.3)",
        background: "#cd113b",
        border: '1px solid #ffffff91',
        position: 'relative',
        zIndex: 100,
      }}
    >
      <div className="login-introduction">
        <img src={Logo} alt="Jachai Logo" />
        <h2 className="heading">{`LET'S`} GOT YOU STARTED</h2>

        <h3 style={{ fontWeight: "lighter", fontFamily: "inherit" }}>
          Welcome to JaChai Admin
        </h3>
        <div className="role-icon-lists">
          <span>&copy; Jachai.com Ltd </span>
          <ul>
            <li>
              <img src={img1} alt="login role" />
            </li>
            <li>
              <img src={img2} alt="login role" />
            </li>
            <li>
              <img src={img7} alt="login role" />
            </li>
            <li>
              <img src={img10} alt="login role" />
            </li>
            <li>
              <img src={img11} alt="login role" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LoginIntro;
